import React from 'react';
import { TextStyled } from '@nike/nike-design-system-components';

const SecEmeaCutoverChina = () => (
  <div style={{ paddingBottom: '10px', marginBottom: '12px' }}>
    <TextStyled bold appearance='body1'>
      注意
    </TextStyled>
    <TextStyled>受 Nike 企业系统升级影响，请注意以下即将出现的网站问题。</TextStyled>
    <br />
    <div style={{ lineHeight: '2' }}>
      <TextStyled>
        系统于
        <TextStyled bold display='inline'>
          2025年12月22日
        </TextStyled>
        前收到订单将保证在
        <TextStyled bold display='inline'>
          12月26
        </TextStyled>
        前发货。
      </TextStyled>
      <TextStyled>
        自
        <TextStyled bold display='inline'>
          2025年12月22日
        </TextStyled>
        零时起，“购物”功能将暂停，但用户仍可登陆管理账户信息。
      </TextStyled>
      <TextStyled>
        自
        <TextStyled bold display='inline'>
          2026年1月6日
        </TextStyled>
        零时起，网站功能恢复正常运营。
      </TextStyled>
    </div>
    <br />
    <TextStyled bold appearance='body1'>
      Notice
    </TextStyled>
    <TextStyled>Due to a Nike Enterprise systems upgrade, please be aware of the upcoming site impacts.</TextStyled>
    <br />
    <div style={{ lineHeight: '1.25' }}>
      <TextStyled>
        Orders received by December 22nd, 2025 will be guaranteed to ship before December 26, 2025.
      </TextStyled>
      <br />
      <TextStyled>
        <TextStyled bold display='inline'>
          December 22
        </TextStyled>{' '}
        - 00:00 CST GC time
        <br />
        Shopping will be disabled. User can continue to access Account information.
      </TextStyled>
      <br />
      <TextStyled>
        <TextStyled bold display='inline'>
          January 6
        </TextStyled>{' '}
        - 00:00 CST <br />
        Site functionality returns to normal.
      </TextStyled>
    </div>
  </div>
);

export default SecEmeaCutoverChina;
